import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

interface Props {
	isManagerOrAdmin: boolean;
	isAccountingOrAdmin: boolean;
	isSuperIntendent: boolean;
	isOwner: boolean;
	isReadOnly: boolean;
	showHistory?: boolean;
	eligableForRemoval: boolean;
	openViewHistoryModal?: () => void;
	handleEdit: () => void;
	remove: () => Promise<void>;
}

const TimeSheetRowActions: React.FC<Props> = (props: Props) => {
	const {
		isManagerOrAdmin,
		isAccountingOrAdmin,
		isSuperIntendent,
		isOwner,
		isReadOnly,
		handleEdit,
		openViewHistoryModal,
		showHistory = true,
		remove,
		eligableForRemoval,
	} = props;

	const showEdit = isOwner || isSuperIntendent || isManagerOrAdmin;
	const showHistoryButton = showHistory && (isManagerOrAdmin || isSuperIntendent || isAccountingOrAdmin);
	const showRemoveButton = eligableForRemoval && (isSuperIntendent || isManagerOrAdmin);

	return (
		<div className={styles['actions-container']}>
			{showHistoryButton && !!openViewHistoryModal &&
				<Button
					icon="ListDefault"
					label="View Timesheet History"
					onClick={openViewHistoryModal}
					style="link"
				/>
			}
			{showEdit && (
				<Button
					icon={isReadOnly ? 'ActionSearch' : 'ActionEdit'}
					label={isReadOnly ? 'Preview' : 'Edit'}
					onClick={handleEdit}
					style="link"
				/>
			)}
			{showRemoveButton && (
				<Button
					icon="Delete"
					label="Remove"
					onClick={remove}
					style="link-danger"
				/>
			)}
		</div>
	);
};

export default React.memo(TimeSheetRowActions);
